"use client";

import * as React from "react";
import { Quote, Play } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
const testimonials = [{
  id: 1,
  quote: "Ostara provided a sanctuary for my healing. The clinical expertise combined with a grounded, earthy approach helped me navigate my anxiety in a way I never thought possible.",
  author: "Julianne Miller",
  role: "Therapy Client",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599111/img/spiritual_session_action_1.png"
}, {
  id: 2,
  quote: "Growing with Ostara as a clinician has been transformative. The supportive environment and focus on holistic wellness make this more than just a practice—it's a community.",
  author: "David K. Rivera",
  role: "Licensed Mental Health Counselor",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599111/img/spiritual_session_action_2.png"
}, {
  id: 3,
  quote: "I found a space here that truly understands the seasons of life. My journey through their group sessions has been a profound source of renewal and personal growth.",
  author: "Maya Rodriguez",
  role: "Wellness Participant",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599111/img/spiritual_session_action_3.png"
}];
export default function VoicesOfTransformation() {
  return;
}